import seniorPlaymat from "../../assets/images/WRO2021-Senior.png";


export default (theme) => ({
  root: {
    padding: "80px 0 0 0",
    // backgroundColor: '#E5E5E5'
    fontFamily: "'Open Sans', sans-serif",
  },
  playmat: {
    backgroundImage: `url(${seniorPlaymat})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  button: {
    height: 40,
    marginBottom: 24,
    marginRight: 24,
    marginLeft: 24,
    minWidth: 150
  }
});
